module.exports = __webpack_public_path__ + "static/media/cfvn-logo-dark.d04ac81f.svg";